import React from 'react'
import { Helmet } from 'react-helmet'
import { PostStyle, PostStyleContainer, Banner, Title, Date, PreText, Text, SubTitle, Media } from './postStyle'

import Thumb1 from '../../assets/blog/posts/Imagenes-Blog2-1024x691.png'
import Thumb2 from '../../assets/blog/posts/Imagenes-Blog3-1024x691.png'
import Thumb3 from '../../assets/blog/posts/Imagenes-Blog4-1.png'
import Thumb4 from '../../assets/blog/posts/Imagenes-Blog5-1.png'
import Thumb5 from '../../assets/blog/posts/Imagenes-Blog6-1.png'
import Thumb6 from '../../assets/blog/posts/Imagenes-Blog7-1-1.png'
import Thumb7 from '../../assets/blog/posts/Imagenes-Blog8-1024x481.png'

export default function Post() {
  return (
    <>
      <Helmet>
        <title>¿Por qué hoy todo el mundo habla de emprender? - oBoticario</title>
        <meta property="og:title" content="¿Por qué hoy todo el mundo habla de emprender? - oBoticario" />
        <meta property="og:description" content="¿Tendencia o estilo de vida? En la actualidad es muy común escuchar la palabra emprender, sin embargo, muchos aún no tenemos claridad de lo que esto realmente significa, pues lo asociamos con la idea de lograr esa independencia y estabilidad económica que tanto soñamos conseguir en un negocio." />
        <meta property="og:url" content="https://emprendeoboticario.com.co/por-que-hoy-todo-el-mundo-habla-de-emprender/" />
	      <meta property="og:url" content="https://emprendeoboticario.com.co/por-que-hoy-todo-el-mundo-habla-de-emprender/" />
        <link rel="canonical" href="https://emprendeoboticario.com.co/por-que-hoy-todo-el-mundo-habla-de-emprender/" />
      </Helmet>

      <PostStyle>
        <PostStyleContainer>
          <Title>
            ¿Por qué hoy todo el mundo habla de emprender?
          </Title>
          <Date><span>oBoticário</span> / 29 enero, 2021</Date>

          <PreText>
            ¿Tendencia o estilo de vida? En la actualidad es muy común escuchar la palabra emprender, sin embargo, muchos aún no tenemos claridad de lo que esto realmente significa, pues lo asociamos con la idea de lograr esa independencia y estabilidad económica que tanto soñamos conseguir en un negocio.
          </PreText>
        </PostStyleContainer>

        <Banner />

        <PostStyleContainer>
          <PreText primary>
            Pero, realmente ¿esto es lo que significa emprender? A continuación, te contaremos todo lo que necesitas saber sobre este proceso y de qué manera podrás iniciar tu propio negocio. 
          </PreText>

          <SubTitle>
            ¿Qué es emprender y quién es un emprendedor?
          </SubTitle>

          <Text>
            Podemos definir la palabra emprender como la acción de dar el primer paso, con hacer realidad una idea comercial a través de la creatividad, la innovación, la pasión y la estrategia para alcanzar unos objetivos, entre estos, obtener un ingreso extra, a mediano o largo plazo.
          </Text>
          <Text>
            También podemos decir que un emprendedor es alguien conocido por su iniciativa, su liderazgo y por aprovechar las oportunidades de una forma distinta para superarse, pero, sobre todo es una persona apasionada, disciplinada y enfocada en cumplir sus metas y proyectos.
          </Text>

          <Media>
            <Text>
              Para ser más claros te daremos algunos ejemplos de emprendedores líderes en el último siglo como lo es: Steve Jobs, fundador de Apple, una de las empresas más exitosas de la historia recientes; Bill Gates, fundador de Microsoft, compañía tecnológica multinacional; o el mismo Dr. Miguel Krigsner, fundador de OBoticário, la marca de belleza preferida por los brasileros reconocida a nivel mundial. <br /> <br />
              Estos emprendedores, que a través de sus ideas lograron alcanzar el éxito y son la muestra de que un trabajo con esfuerzo, dedicación y objetivos claros hace que todo sea posible y que a través del emprendimiento se pueda cambiar el mundo.
            </Text>
            <img src={Thumb1} />
          </Media>

          <Text>
            Ahora, te estarás preguntando ¿Cuál es el camino correcto para iniciar un emprendimiento? Nosotros sabemos que cada emprendedor tiene su metodología y su recorrido es diferente, pero se pueden encontrar algunas similitudes entre los emprendedores exitosos que seguramente te ayudarán a empezar de una forma más asertiva y eficaz:
          </Text>

          <Media>
            <Text>
              El primer paso, sin duda alguna, es visualizar tus metas; es el más sencillo, pero también el más importante, ya que este será tu combustible para mantener tu emprendimiento a flote. <br /> <br />
              Por otro lado, sugerimos que te concentres en encontrar tus pasiones y habilidades para que puedas convertirlas en oportunidades, por ejemplo, si lo tuyo es la belleza puedes emprender con una empresa líder en el sector como OBoticário y distribuir nuestros productos de forma independiente, lo que te permitirá tener el control de tus finanzas mientras trabajas en lo que más te gusta.
            </Text>
            <img src={Thumb2} />
          </Media>

          <Text>
            Finalmente planea y ejecuta una estrategia que te permita tener objetivos claros, esto te ayudará a tener un plan de acción real y trazarte metas que puedas cumplir, también puedes apoyarte en herramientas digitales como las redes sociales, donde podrás usar videos, imágenes y muchos otros recursos que te ayudarán a ser más visible de una manera rápida y sencilla. <br /> <br />
            Ahora bien, ya que tenemos claro qué es y cómo hacerlo, también te interesará:
          </Text>

          <SubTitle>
            ¿Qué beneficios obtienen los emprendedores?
          </SubTitle>

          <Media small>
            <img src={Thumb3} />
            <Text>
              Como emprendedor tendrás el control de tus actividades y podrás tomar decisiones de una forma autónoma en tu emprendimiento.
            </Text>
          </Media>

          <Media small>
            <img src={Thumb4} />
            <Text>
              Si tu proyecto está bien planteado y ejecutado seguramente tus ingresos serán mayores, lo que te permitirá reinvertir en tu emprendimiento y alcanzar tus metas personales.
            </Text>
          </Media>

          <Media small>
            <img src={Thumb5} />
            <Text>
              Tendrás la satisfacción personal de crear y trabajar en tu propio proyecto, al cual habrás dedicado tiempo y recursos para verlo crecer hasta el punto de generar ganancias.
            </Text>
          </Media>

          <Media small>
            <img src={Thumb6} />
            <Text>         
              Pero lo más importante, aprenderás más sobre lo que te apasiona y serás un verdadero experto; entre más te enfoques en capacitarte sobre tu emprendimiento tendrás las herramientas necesarias para brindarle a tus clientes un mejor servicio y asesoría.
            </Text>
          </Media>

          <Text>
            Es por esto que nuestros Emprendedores OBoticário reciben capacitaciones frecuentemente en gente con un amplio conocimiento en el tema, con el fin de apoyar sus proyectos de emprendimiento.
          </Text>

          <SubTitle highlight>
            Recuerda que el sector de los cosméticos y la belleza en Colombia es uno de los más rentables, así que, si buscas iniciar tu emprendimiento de una manera, fácil, divertida, pero exitosa, OBoticário es tu mejor opción.
          </SubTitle>

          <img src={Thumb7} />

          <Text>
            Si este artículo te ha aclarado la mayor parte de tus dudas y estás pensando en cuál es el mejor momento para emprender, realmente la respuesta es muy sencilla, ¡El mejor momento es hoy y ahora!
          </Text>

          <Text>
            Este preciso instante es tu oportunidad para empezar tu propio negocio y más si siempre has querido intentarlo y explorar en el sector de belleza.
          </Text>

          <Text>
            Además, que te brindará una nueva oportunidad económica, donde hoy más que nunca el momento histórico nos exige ser creativos y estratégicos. Así que no lo pienses más, emprende con OBoticário, una oportunidad que te permita tener tus propias normas, aumentar tus ganancias y, por supuesto, llevar belleza a toda Colombia.
          </Text>

          <SubTitle highlight>
            ¡Emprende con nosotros, comparte amor y belleza, cumple tus metas!
          </SubTitle>
          <SubTitle>
            #DondeHayAmorHayBelleza
          </SubTitle>
        </PostStyleContainer>
      </PostStyle>
    </>
  )
}